import './App.css'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import LandingPage from './Pages/Pages/LandingPage/LandingPage'
import Login from './Pages/Pages/Login/Login'
import Home from './Pages/Pages/Home/Home'
import RCAccept from './Pages/Pages/RCAccept/RCAccept'
import UploadData from './Pages/Pages/UploadData/UploadData'
import GenerateLC from './Pages/Pages/GenerateLC/GenerateLC'
import PreviousLC from './Pages/Pages/PreviousLC/PreviousLC'
import UploadCgpa from './Pages/Pages/UploadCgpa/UploadCgpa'
import Vacation from './Pages/Pages/Vacation/Vacation'
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />}></Route>
        <Route path="/home" element={<Home />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/upload-data" element={<UploadData />}></Route>
        <Route path="/vacation" element={<Vacation />}></Route>
        <Route path="/lc-generate" element={<GenerateLC />}></Route>
        <Route path="/rc-accept" element={<RCAccept />}></Route>
        <Route path="/previous-lc" element={<PreviousLC />}></Route>
        <Route path="/upload-cgpa" element={<UploadCgpa/>}></Route>
      </Routes>
    </Router>
  )
}

export default App
